package uz.ferro.erp.feature.property.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.model.DictItem

@Serializable
data class Property(
    val id: Long? = null,
    val key: String? = null,
    val value: String? = null,
    val name: DictItem? = null,
    val displayValue: DictItem? = null
)